import { Lookup } from './lookup.interface';

export interface ApplicationPovLookup extends Lookup {
  default?: boolean;
  applicantSpouse?: boolean;
  oboSingle?: boolean;
  oboSpouse?: boolean;
}

//restrict pov's to these
export type Povs = 'default' | 'applicantSpouse' | 'oboSingle' | 'oboSpouse';

export const ApplicationPov: Record<Povs, ApplicationPovLookup> = {
  default: {
    code: 'default',
    displayValue: 'Content from 2nd person POV of applicant who is single (default)',
  },
  applicantSpouse: {
    code: 'applicantSpouse',
    displayValue: 'Content from 2nd person POV of applicant with a spouse/partner',
    applicantSpouse: true,
  },
  oboSingle: {
    code: 'oboSingle',
    displayValue: 'Content from 3rd person POV of applicant who is single',
    oboSingle: true,
  },
  oboSpouse: {
    code: 'oboSpouse',
    displayValue: 'Content from 3rd person POV of applicant with a spouse/partner',
    oboSpouse: true,
  },
};
